import { useEffect, useRef } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../../utils/backendURL';
import { showError } from '../../utils/notifications';

export function rememberOverviewHistory(test) {
  const params = new URLSearchParams(window.location.search);
  params.set('overview_test', test.id);
  params.set('overview_type', test.type);
  params.set('tab', test.type === 'flow_test' ? 'executions' : 'history');
  window.history.replaceState(window.history.state, '', `${window.location.pathname}?${params}`);
}

export function clearOverviewHistory(params) {
  params.delete('overview_test');
  params.delete('overview_type');
}

export default function useOverviewHistory(kind, selected, onConsumed, onOpen) {
  const callbacks = useRef({ onConsumed, onOpen });
  callbacks.current = { onConsumed, onOpen };
  const handled = useRef('');
  const params = new URLSearchParams(window.location.search);
  const selectedId = selected?.type === kind ? selected.id : null;
  const id =
    selectedId || (params.get('overview_type') === kind ? params.get('overview_test') : null);
  useEffect(() => {
    if (!id || handled.current === id) return;
    const controller = new AbortController();
    const open = async () => {
      try {
        const surface = kind === 'flow_test' ? 'flow-testing' : 'api-testing';
        const response = await axios.get(
          `${BACKEND_URL}/api/${surface}/tests/${encodeURIComponent(id)}`,
          { signal: controller.signal },
        );
        if (controller.signal.aborted) return;
        await callbacks.current.onOpen({ ...response.data, type: kind });
        handled.current = id;
        callbacks.current.onConsumed?.();
      } catch (_) {
        if (!controller.signal.aborted)
          showError('Unable to open this test history. Refresh and try again.');
      }
    };
    open();
    return () => controller.abort();
  }, [id, kind]);
}
